
export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-gradient-to-r from-amber-500 to-orange-500">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
            지금 바로 주문하세요
          </h2>
          <p className="text-xl text-white/90 mb-12 leading-relaxed">
            이번 추석, 소중한 분들께 아무거나 선물할 수 없습니다.<br/>
            말로 다 할 수 없는 감사의 마음을 최고의 품격으로 전하십시오.
          </p>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 mb-12">
            <h3 className="text-2xl font-bold text-white mb-6">
              📞 주문 문의
            </h3>
            <div className="text-center">
              <p className="text-white/90 text-lg mb-4">한의사 노태균 원장</p>
              <a 
                href="tel:010-6607-5556" 
                className="inline-flex items-center bg-white text-amber-600 px-8 py-4 rounded-full text-2xl font-bold hover:shadow-lg transition-all cursor-pointer"
              >
                <i className="ri-phone-line mr-3"></i>
                010-6607-5556
              </a>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-white">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <i className="ri-time-line text-4xl mb-4"></i>
              <h4 className="text-lg font-bold mb-2">운영시간</h4>
              <p className="text-white/90">
                평일 09:00 - 18:00<br/>
                토요일 09:00 - 15:00
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <i className="ri-truck-line text-4xl mb-4"></i>
              <h4 className="text-lg font-bold mb-2">배송안내</h4>
              <p className="text-white/90">
                전국 무료배송<br/>
                주문 후 2-3일 내 발송
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <i className="ri-shield-check-line text-4xl mb-4"></i>
              <h4 className="text-lg font-bold mb-2">품질보증</h4>
              <p className="text-white/90">
                100% 국내산 원료<br/>
                신선도 보장
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}